import React from "react";
import { RetryButton } from "./AdminUi";

const ACTION_LABELS = {
  DOCUMENTATION_CREATED: "إنشاء الطلب",
  DOCUMENTATION_UPDATED: "تحديث التوثيق",
  DOCUMENTATION_COMPLETED: "اكتمال التوثيق",
  CONCLUSION_ADDED: "إضافة نتيجة",
  CONCLUSION_REVERTED: "التراجع عن نتيجة",
  OUTCOME_NOTE_ADDED: "إضافة ملاحظة",
  EVIDENCE_UPLOADED: "رفع دليل",
  EVIDENCE_REPLACED: "استبدال دليل",
  EVIDENCE_DELETED: "حذف دليل",
  STORE_INVOICE_CREATED: "توثيق فاتورة متجر",
  INVOICE_FILE_REPLACED: "استبدال فاتورة",
  INVOICE_FILE_DELETED: "حذف فاتورة",
  SOFT_DELETED: "حذف السجل",
};

function valueText(value) {
  if (value == null || value === "") return "غير متوفر";
  if (typeof value === "object")
    return value.url ? value.originalName || "ملف" : "تغيير متعدد";
  if (typeof value === "boolean") return value ? "نعم" : "لا";
  return String(value);
}

export default function AuditTimeline({ items = [], loading, error, onRetry }) {
  if (loading) return <div className="admin-empty">جاري تحميل السجل…</div>;
  if (error)
    return (
      <div className="admin-empty admin-error">
        {error}
        {onRetry && (
          <RetryButton onClick={onRetry} />
        )}
      </div>
    );
  if (!items.length)
    return <div className="admin-empty">لا يوجد سجل تغييرات مطابق.</div>;
  return (
    <div className="audit-timeline">
      {items.map((item) => (
        <article className={`audit-item ${item.status || ""}`} key={item.id}>
          <div className="audit-dot" />
          <div className="audit-card">
            <div className="audit-head">
              <b>{ACTION_LABELS[item.action] || item.action}</b>
              <time>
                {item.timestamp
                  ? new Date(item.timestamp).toLocaleString("ar-SA")
                  : "بدون وقت"}
              </time>
            </div>
            <div className="audit-meta">
              {item.actor?.name || item.actor?.email || "ممثل غير معروف"}
              {item.field ? ` · ${item.field}` : ""}
              {item.entityType ? ` · ${item.entityType}` : ""}
            </div>
            {(item.oldValue != null || item.newValue != null) && (
              <div className="audit-diff">
                <span>السابق: {valueText(item.oldValue)}</span>
                <span>الجديد: {valueText(item.newValue)}</span>
              </div>
            )}
            {item.context && <p>{String(item.context)}</p>}
            {(item.file?.url || item.relatedFile?.url) && (
              <div className="audit-files">
                {item.file?.url && (
                  <a href={item.file.url} target="_blank" rel="noreferrer">
                    <img src={item.file.url} alt="previous evidence" />
                    <span>السابق</span>
                  </a>
                )}
                {item.relatedFile?.url && (
                  <a
                    href={item.relatedFile.url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={item.relatedFile.url}
                      alt="replacement evidence"
                    />
                    <span>الحالي / البديل</span>
                  </a>
                )}
              </div>
            )}
          </div>
        </article>
      ))}
    </div>
  );
}
